import { ERROR_PATH, ROOT_PATH, VISITOR_REGISTRATION_PATH, VISITS_SUB_PATH } from 'shared/consts';
import { Route, Routes } from 'react-router-dom';

import { DefaultRedirect } from './default-redirect';
import { ErrorPage } from 'pages/error';
import { PrivateRoute } from 'components/root/private-route';
import React from 'react';
import { VisitorRegistrationRoot } from 'components/visitor-registration-root';
import { VisitorRegistrationLayout } from 'components/root/router/visitor-registration-route/visitor-registration-layout';
import { VisitsV2Layout } from 'components/root/router/visitor-registration-route/visits-v2-layout';
import { VisitsRoutes } from 'components/root/router/visitor-registration-route/visits-routes';
import { VisitsRedirect } from 'components/root/router/visitor-registration-route/visits-redirect';

export const Router: React.FC = (): JSX.Element => (
  <Routes>
    {/* Use /* to allow nested routes under ROOT_PATH */}
    <Route
      path={`${ROOT_PATH}/*`}
      element={
        <PrivateRoute>
          <VisitorRegistrationLayout />
        </PrivateRoute>
      }
    >
      {/* Nested routes inside VisitorRegistrationLayout */}
      {/* VisitsV2Layout conditionally renders V1 or V2 based on flag */}
      <Route path={`${VISITS_SUB_PATH}/*`} element={<VisitsV2Layout />}>
        {/* V1 routes - only rendered when flag is false */}
        <Route path="*" element={<VisitsRoutes />} />
      </Route>
      {/* Default redirect if not under visits */}
      <Route path="*" element={<VisitsRedirect />} />
    </Route>
    <Route path={VISITOR_REGISTRATION_PATH} element={<VisitorRegistrationRoot />} />
    <Route path={ERROR_PATH} element={<ErrorPage />} />
    <Route path="/" element={<VisitorRegistrationRoot />} />
    <Route path="*" element={<DefaultRedirect />} />
  </Routes>
);
